import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { addNewRelicPageAction } from 'ddc-new-relic';
import './EventViewer.scss';

// drag it around: https://www.kirupa.com/html5/drag.htm

export default function EventViewer(props) {
	useEffect(() => {
		// monitor usage of eventViewer fuctionality
		// if there is a huge spike in activity could be a bug in how it shows
		addNewRelicPageAction('ws-tagging-event-viewer');
		function handleBeforeUnload(event) {
			const e = event;
			e.returnValue = 'Are you sure you want to leave?';
		}
		window.addEventListener('beforeunload', handleBeforeUnload);
		return () =>
			window.removeEventListener('beforeunload', handleBeforeUnload);
	});

	return ReactDOM.createPortal(
		<div className="ws-tagging-event-viewer">
			{props.data.map(({ detail, eventViewerCount }) => (
				<React.Fragment>
					<div>{eventViewerCount}</div>
					<pre>{JSON.stringify(detail, null, 2)}</pre>
				</React.Fragment>
			))}
		</div>,
		document.getElementsByTagName('body')[0]
	);
}

EventViewer.propTypes = {
	count: PropTypes.number,
	data: PropTypes.arrayOf(PropTypes.shape)
};
